import { render } from "./ManageUsersClinicalHealthSystemsOverlay.vue?vue&type=template&id=48b74ac1&scoped=true&lang=pug"
import script from "./ManageUsersClinicalHealthSystemsOverlay.vue?vue&type=script&lang=js"
export * from "./ManageUsersClinicalHealthSystemsOverlay.vue?vue&type=script&lang=js"

import "./ManageUsersClinicalHealthSystemsOverlay.vue?vue&type=style&index=0&id=48b74ac1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b74ac1"]])

export default __exports__